export interface Produto {
  id: string;
  nome: string;
  preco: number;
  ativo: boolean;
  created_at: string;
}

export type StatusVenda = "Pendente" | "Enviado" | "Pago";

export interface Venda {
  id: string;
  cliente_nome: string;
  graduacao: string;
  telefone: string;
  valor_total: number;
  vencimento: string;
  modalidade?: string;
  status: StatusVenda;
  arquivado?: boolean;
  observacao?: string;
  created_at: string;
}

export interface ItemVenda {
  id: string;
  venda_id: string;
  produto_id: string;
  nome_produto: string;
  quantidade: number;
  preco_unitario: number;
  subtotal: number;
  created_at: string;
}

export interface ItemVendaComProduto extends ItemVenda {
  produtos: Pick<Produto, "nome"> | null;
}

export interface VendaComItens extends Venda {
  itens_venda: ItemVendaComProduto[];
}

export interface CriarItemVendaInput {
  produto_id: string;
  nome_produto: string;
  quantidade: number;
  preco_unitario: number;
}

export interface CriarVendaInput {
  cliente_nome: string;
  graduacao: string;
  telefone: string;
  observacao?: string;
  vencimento: string;
  modalidade?: string;
  status?: StatusVenda;
  itens: CriarItemVendaInput[];
}

export interface Despesa {
  id: string;
  descricao: string;
  valor: number;
  data_compra: string;
  created_at: string;
}

export const GRADUACOES = [
  "Civil",
  "Recruta",
  "Sd",
  "Cb",
  "3º Sgt",
  "2º Sgt",
  "1º Sgt",
  "Subten",
  "Asp",
  "2º Ten",
  "1º Ten",
  "Ten",
  "Cap",
  "Maj",
  "Ten Cel",
  "Cel",
  "Gen",
] as const;

export type Graduacao = (typeof GRADUACOES)[number];
